var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-search-white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-white",
    clipPath: "url(#clip-search-white)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34498",
    "data-name": "Path 34498",
    d: "M17.587,12.741a6.481,6.481,0,1,0-1.143,1.142l.035.037,3.434,3.435a.81.81,0,0,0,1.146-1.146l-3.435-3.434-.037-.034Zm-1.68-7.406a4.856,4.856,0,1,1-6.868,0,4.856,4.856,0,0,1,6.868,0Z",
    transform: "translate(-3.645 0.055)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.d2ac2df1b05839f8e0d5d4bc78ee9fd0.svg";
export { ForwardRef as ReactComponent };